import { ChangeEvent } from 'react'
import { TextAreaProps } from 'semantic-ui-react'
import classNames from 'classnames'

import { Form } from 'client/semantic-imports'
import { AppFormFieldLabel } from 'client/ui-building-blocks'

import styles from './app-form-text-area.module.scss'

type AppFormTextAreaProps = {
  id?: string
  placeholder?: string
  rows?: number
  resizable?: boolean
  maxLength?: number
  autoComplete?: string
  spellCheck?: boolean
  label: string
  disabled?: boolean
  error?: string
  value: string
  onChange: (e: ChangeEvent<HTMLTextAreaElement>, data: TextAreaProps) => void
}

const AppFormTextArea = (props: AppFormTextAreaProps) => {
  const {
    id,
    placeholder = '',
    rows = 5,
    resizable = false,
    maxLength,
    autoComplete = 'off',
    spellCheck = false,
    label = '',
    disabled = false,
    error = '',
    value,
    onChange,
  } = props

  return (
    <div
      className={classNames(
        styles.appFormTextArea,
        error && 'error',
        resizable && styles['resizable']
      )}
    >
      <Form.TextArea
        id={id}
        placeholder={placeholder}
        rows={rows}
        maxLength={maxLength}
        autoComplete={autoComplete}
        spellCheck={spellCheck}
        disabled={disabled}
        label={<AppFormFieldLabel label={label} error={error} />}
        value={value}
        onChange={onChange}
      />
    </div>
  )
}

export default AppFormTextArea
